import Page, { PageProps } from '@/components/page/Page';

export type PublicPageProps = PageProps;

const PublicPage = (props: PublicPageProps) => <Page {...props} />;

export default PublicPage;
